<template>
    <div class="product-family__results">
        <template v-if="results?.length > 0">
            <div class="product-family__num-results">
                Showing Results: 1 - {{ results.length }} of
                {{ results.length }}
            </div>
            <ul class="product-family__results-list">
                <li v-for="result in results" class="product-family__results-item">
                    <ProductFamilyResultsCard :type="result.itemType" :product="result.product" :category="result.category" :translations="translations"> </ProductFamilyResultsCard>
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts">
import ProductFamilyResultsCard from 'Vue/components/productFamily/ProductFamilyResultsCard.vue';
import { IProductFamilyTranslations } from 'Vue/interfaces/Interfaces';
export default {
    name: 'ProductFamilyResults',
    data() {
        return {
            isSet: false,
        };
    },
    components: {
        ProductFamilyResultsCard,
    },
    props: {
        results: {
            type: Array,
            default: () => [] as any[],
        },
        translations: {
            type: Object,
            default: {} as IProductFamilyTranslations,
        },
    },
    mounted() {
        this.isSet = true;
    },
};
</script>
